import type { User } from '@paintscout/api'
import React, { useRef } from 'react'
import { useCalendar } from '../CalendarContext'
import { CalendarEstimatorSelect } from '../../CalendarToolbar'

export default function SalesCalendarEstimatorSelect() {
  const { selectedUsers, setSelectedUsers, view, tab } = useCalendar()
  const selectedUsersBeforeClick = useRef<User[]>(selectedUsers)

  const handleClick = (user: User, e: React.MouseEvent) => {
    if (e.detail === 1) {
      selectedUsersBeforeClick.current = selectedUsers
    }
    // Can only select one user at a time in day and week view
    if (view !== 'month') {
      setSelectedUsers([user])
      return
    }
    if (selectedUsers.some((u) => u.user_id === user.user_id)) {
      setSelectedUsers(selectedUsers.filter((u) => u.user_id !== user.user_id))
    } else {
      setSelectedUsers([...selectedUsers, user])
    }
  }

  const handleDoubleClick = (allUsers: User[]) => {
    if (view !== 'month') return
    const allWereSelected = selectedUsersBeforeClick.current.length === allUsers.length
    setSelectedUsers(allWereSelected ? [] : allUsers)
  }

  return (
    <CalendarEstimatorSelect
      selectedUsers={selectedUsers}
      tab={tab}
      onClick={handleClick}
      onDoubleClick={handleDoubleClick}
    />
  )
}
